import S from "common/service/sanctuary";
import React, { Fragment } from "react";
import { compose } from "ramda";
import { connect } from "react-redux";
import { func, string, bool } from "prop-types";
import {
  FormattedMessage,
  defineMessages,
  intlShape,
  injectIntl,
} from "react-intl";
import Button from "common/mdc/button";
import { ResourceWrapper } from "common/mdc/wrappers";
import Form, { Error, DisplayField } from "common/mdc/form/index";
import TextField from "common/mdc/textfield/index";
import { namespace } from "d3";
import { selectors, actions } from "@sma/store/job/jobs";
import Dialog, { withConfirmationDialog } from "common/mdc/dialog";

import "./steps/createNewJob.scss";
import Stepper, { Step } from 'common/mdc/stepper';
import Step1, { STEP_ID as STEP_ID_1, title as title1 } from './steps/step1';
import Step2, { STEP_ID as STEP_ID_2, title as title2 } from './steps/step2';
import Step3, { STEP_ID as STEP_ID_3, title as title3 } from './steps/step3';
import Step4, { STEP_ID as STEP_ID_4, title as title4 } from './steps/step4';

import { actions as groupsActions } from "@sma/store/group/groups";

import WithDialog from "common/mdc/dialog/withDialog";
import PreviewNewJob from "./previewNewJob/previewNewJob";

export {
  STEP_ID_1,
};

const messages = defineMessages({
  cancel: {
    id: 'jobCreate.actions.cancel',
    defaultMessage: 'Cancel',
  },
  cancelConfirmation: {
    id: 'jobCreate.actions.cancelConfirmation',
    defaultMessage: 'Are you sure you want to cancel? Unsaved changes will be lost.',
  },
});

class CreateNewJob extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const {
      onClose,
      onClick,
      initialStep,
      showCreateJobDialog,
      cancelDialogPopup,
      groupsSearchAction,
      clearSearch,
      showPreviewDialog,
    } = this.props;

    const CancelAction = () => {
      return <Button
        type="reset"
        onClick={() => cancelDialogPopup({ resolve: () => {
                                                            showCreateJobDialog(false);
                                                            clearSearch();
                                                          }
                                          }
                                        )}>
        <FormattedMessage {...messages.cancel} />
      </Button>
    }

    const buttons = (
      <Fragment>

      </Fragment>
    );

    return (
      <Dialog
        title={"Create New Job"}
        onClose={onClose}
        buttons={buttons}
        loading={false}
        onClick={onClick}
        className={"create-job-dialog"}
      >
        <div className="create-job-content">
          <Stepper
            initialStep={initialStep}
          >
            <Step
              title={title1}
              stepId={STEP_ID_1}
            >{stepper => (
              <Step1
                stepper={stepper}
                cancelAction={<CancelAction />}
              />
            )}
            </Step>
            <Step
              title={title2}
              stepId={STEP_ID_2}
            >{stepper => (
              <Step2
                stepper={stepper}
                cancelAction={<CancelAction />}
              />
            )}
            </Step>
            <Step
              title={title3}
              stepId={STEP_ID_3}
            >{stepper => (
              <Step3
                stepper={stepper}
                cancelAction={<CancelAction />}
              />
            )}
            </Step>
            <Step
              title={title4}
              stepId={STEP_ID_4}
            >{stepper => (
              <Step4
                stepper={stepper}
                cancelAction={<CancelAction />}
              />
            )}
            </Step>
          </Stepper>
        </div>
        {showPreviewDialog ? <PreviewNewJob/> : null}
      </Dialog>
    );
  }
}

CreateNewJob.defaultProps = {
  initialStep: STEP_ID_1,
};

const CancelDialogPopup = ({ buttons, onClose }) => (
  <Dialog
    title={"Cancel?"}
    buttons={buttons}
    onClose={onClose}
  >
    <FormattedMessage {...messages.cancelConfirmation} />
  </Dialog>
);

CancelDialogPopup.propTypes = {};

export default compose(
  connect(
    (state) => ({
      //state
      showPreviewDialog: state.job.jobs.showPreviewDialog,
    }),
    {
      //actions
      showCreateJobDialog: actions.showCreateJobDialog,
      groupsSearchAction: groupsActions.search,
      clearSearch: groupsActions.clearSearch,
    }
  ),
  injectIntl,
  withConfirmationDialog(CancelDialogPopup, 'cancelDialogPopup'),
  WithDialog(PreviewNewJob, 'previewNewJob'),
)(CreateNewJob);
